import PropTypes from 'prop-types';
import Immutable from 'seamless-immutable';

import { actions } from './actions';

import { IOS_PLATFORM, ANDROID_PLATFORM } from '../../utils/platforms';

const defaultState = {
  product: null,
  loading: true,
  error: null,
  updatingInfo: false,
  updatingBundles: {
    [IOS_PLATFORM]: false,
    [ANDROID_PLATFORM]: false,
  },
  updatingImages: [false, false, false, false],
  assigning: false,
  assignError: false,
  overrideOpen: false,
  edditingOverride: false,
};

/* eslint-disable complexity */
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.CLEAR: {
      return state.merge(defaultState);
    }
    case actions.SET_PRODUCT: {
      return state.merge({
        loading: false,
        product: action.payload.product,
      });
    }
    case actions.LOAD_START: {
      return state.merge({ loading: true });
    }
    case actions.LOAD_FAIL: {
      return state.merge({
        loading: false,
        error: action.payload.error,
      });
    }
    case actions.UPDATE_START: {
      return state.merge({ updatingInfo: true });
    }
    case actions.UPDATE_SUCCESS: {
      return state.merge({ updatingInfo: false });
    }
    case actions.UPDATE_FAIL: {
      return state.merge({ updatingInfo: false });
    }
    case actions.IMAGE_UPDATE_START: {
      const updatingImages = [...state.updatingImages];
      updatingImages[action.payload.index] = true;
      return state.merge({ updatingImages });
    }
    case actions.IMAGE_UPDATE_SUCCESS: {
      const updatingImages = [...state.updatingImages];
      updatingImages[action.payload.index] = false;
      return state.merge({ updatingImages });
    }
    case actions.IMAGE_UPDATE_FAIL: {
      const updatingImages = [...state.updatingImages];
      updatingImages[action.payload.index] = false;
      return state.merge({ updatingImages });
    }
    case actions.BUNDLE_UPDATE_START: {
      return state.merge({
        updatingBundles: Immutable(state.updatingBundles).merge({
          [action.payload.platform]: true,
        }),
      });
    }
    case actions.BUNDLE_UPDATE_SUCCESS: {
      return state.merge({
        updatingBundles: Immutable(state.updatingBundles).merge({
          [action.payload.platform]: false,
        }),
      });
    }
    case actions.BUNDLE_UPDATE_FAIL: {
      return state.merge({
        updatingBundles: Immutable(state.updatingBundles).merge({
          [action.payload.platform]: false,
        }),
      });
    }
    case actions.ASSIGN_CHANGE_START: {
      return state.merge({ assigning: true });
    }
    case actions.ASSIGN_CHANGE_SUCCESS: {
      return state.merge({
        assigning: false,
        product: action.payload.product,
        assignError: null,
        overrideOpen: false,
      });
    }
    case actions.ASSIGN_CHANGE_FAIL: {
      return state.merge({ assigning: false, assignError: action.payload.error });
    }
    case actions.UPDATE_QR: {
      const { qr } = action.payload;
      const product = Immutable(state.product).merge({ qr });
      return state.merge({ product });
    }
    case actions.NEW_OVERRIDE: {
      return state.merge({ overrideOpen: true, edditingOverride: false });
    }
    case actions.EDIT_OVERRIDE: {
      return state.merge({ overrideOpen: true, edditingOverride: true });
    }
    case actions.CLOSE_OVERRIDE: {
      return state.merge({ overrideOpen: false });
    }
    default: {
      return state;
    }
  }
}
/* eslint-enable complexity */

/* ------------- New product form propTypes ------------- */
export const propTypes = {
};



// WEBPACK FOOTER //
// ./src/redux/EditProductForm/reducer.js